"use strict";const t=require("styled-components").css`
    position: relative;
    .DXAlert-container {
        position: fixed;
        z-index: 999999;
    }

    .DXAlert-container-inline {
        position: relative;
        margin-top: 10px;
    }

    .DXAlert-alert {
        box-sizing: border-box;
        position: relative;
        transition: 0.3s ease all;
        position: relative;
        margin: 0 0 10px;
        padding: 7px 10px 10px;
        width: 220px;
        max-width: 100%;
        display: flex;
        flex-direction: column;
        border: 0px solid transparent;
        border-radius: 2px;
        cursor: inherit;
        @media (min-width: ${({theme:t})=>t.breakpoints.small}) {
            width: 300px;
        }
    }

    .DXAlert-container button,
    .DXAlert-container-inline button {
        position: relative;
        float: right;
        outline: none;
        border: none;
        padding: 0;
        cursor: pointer;
        background: 0 0;
        border: 0;
        display: flex;
        justify-content: center;
        align-items: flex-start;
        svg {
            width: 30px;
            height: 30px;
        }
    }

    .DXAlert-alert-header {
        display: flex;
        position: relative;
        flex-direction: row-reverse;
        justify-content: space-between;
    }

    .DXAlert-heading {
        position: relative;
        color: inherit;
        margin: 5px 0px 0px;
    }

    .DXAlert-content {
        position: relative;
        color: inherit;
        margin: 10px 0px 0px;
    }

    .inline-position {
        transition: transform 0.3s ease-in-out;
        animation: toast-in-right 0.4s;
    }

    .top-right {
        top: 6px;
        right: 6px;
        transition: transform 0.3s ease-in-out;
        animation: toast-in-right 0.4s;
    }

    .bottom-right {
        bottom: 6px;
        right: 6px;
        transition: transform 0.3s ease-in-out;
        animation: toast-in-right 0.4s;
    }

    .top-left {
        top: 6px;
        left: 6px;
        transition: transform 0.3s ease-in;
        animation: toast-in-left 0.4s;
    }

    .bottom-left {
        bottom: 6px;
        left: 6px;
        transition: transform 0.3s ease-in;
        animation: toast-in-left 0.4s;
    }

    @keyframes toast-in-right {
        from {
            transform: translateX(20%);
            opacity: 0;
        }
        to {
            transform: translateX(0);
            opacity: 1;
        }
    }

    @keyframes toast-in-left {
        from {
            transform: translateX(-20%);
            opacity: 0;
        }
        to {
            transform: translateX(0);
            opacity: 1;
        }
    }
`;module.exports=t;
//# sourceMappingURL=styles.js.map
